<div class="flex justify-between items-center mb-4 mt-4">
  <div class="flex-1"></div>
  <div class="flex flex-1 justify-center">
    <elcia-period-navigator (periodChange)="setPeriod($event)"
                            [initialDate]="periodStore.period().startDate"
                            [periodTypes]="[PeriodType.Month, PeriodType.Quarter, PeriodType.Year]"/>
  </div>
  <div class="flex flex-1 flex-row-reverse gap-2">
    <elcia-button (onClick)="menu.toggle($event)"
                  [disabled]="exportableInvoiceIds().length === 0 || isExporting()"
                  [icon]="'download'"
                  [isLoading]="isExporting()"
                  [label]="'direct-debit.action' | translate"/>
    <p-menu #menu [model]="menuItems" [popup]="true">
      <ng-template #item let-item>
        <a (click)="run(item.value); menu.hide()" class="p-menu-item-link cursor-pointer flex items-center gap-2">
          <span [class]="item.icon" class="pi"></span>
          {{ item.label | translate }}
        </a>
      </ng-template>
    </p-menu>
  </div>
</div>

<elcia-invoice-grid (creditRequested)="navToCredit($event)" (invoiceSelected)="navToEdit($event)"
                    [invoices]="store.invoices()" [showDirectDebitExport]="true"/>
